// AgentVerse/common/schemas/collections/messagingChannels.js
import { z } from "zod";

const ChannelMemberSchema = z.object({
    contactId: z.string().describe("MessagingContact ID of the member."),
    // contactType: z.enum(["internal_user", "external_contact", "agent"]).describe("Type of the member."), // Redundant, can be derived from MessagingContacts
    role: z.enum(["admin", "member", "moderator", "viewer"]).default("member").describe("Role of the member within this channel."),
    joinedAt: z.coerce.date().optional().describe("When the member joined the channel."),
    // Add other member-specific channel settings if needed (e.g., notification preferences for this channel)
});

const MessagingChannelSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    channelId: z.string().uuid().describe("Globally unique ID for this channel, generated by the system."),
    subscriptionId: z.string().describe("The subscription this channel belongs to."),

    projectId: z.string().describe("The project this channel belongs to."),

    name: z.string().min(1, "Channel name is required.").optional().nullable().describe("Display name of the channel (for groups). Nullable for DMs."),
    topic: z.string().optional().nullable().describe("Optional topic/description for the channel."),
    channelType: z.enum(["group", "direct_message"]).describe("Type of channel."), // 'direct_message' for 1-on-1

    members: z.array(ChannelMemberSchema).min(1).describe("List of members in this channel."),
    // For direct_message, members array will have exactly 2 members.

    avatarUrl: z.string().url().optional().nullable().describe("URL for the channel's avatar (for groups)."),

    createdByContactId: z.string().optional().nullable().describe("MessagingContact ID of the creator."),
    createdAt: z.coerce.date().optional().describe("Timestamp of creation."),
    updatedAt: z.coerce.date().optional().describe("Timestamp of last update."),

    isArchived: z.boolean().default(false).describe("Whether this channel is archived."),
    lastMessageTimestamp: z.coerce.date().optional().nullable().describe("Timestamp of the last message in this channel, for sorting conversations."),
    // lastMessageSnippet: z.string().max(100).optional().nullable().describe("A short snippet of the last message."), // For UI previews

    settings: z.record(z.any()).optional().describe("Channel-specific settings (e.g., notification preferences, join rules).")
});

export default MessagingChannelSchema;
export { ChannelMemberSchema };